import React from 'react';
import Rental from 'views/Rental';

const RentalPage = () => {
  return <Rental />;
};

export default RentalPage;